import React from "react";
import InnovativeProdDevRedesign from "../redesign/InnovativeProdDevRedesign";

const InnovativeProdDev = () => {
  return <InnovativeProdDevRedesign />;
};

export default InnovativeProdDev;
